import './App.css';
import { Header } from '../header/Header';
import { SoundsBlock } from '../soundsBlock/SoundsBlock';
import { AboutBlock } from '../aboutBlock/AboutBlock';
import { Footer } from '../footer/Footer';
import { useState } from 'react';

export const App = () => {
    return (
        <div className="app">
            <Header />
            <SoundsBlock />
            <AboutBlock />
            <Footer />
        </div>
    );
}